/* Klaar UI: behavior for the kl-* sections (gallery, colors, name, sticky bar, carousels, videos). */
(function () {
  if (window.KlaarUI) { window.KlaarUI.init(document); return; }
  var motion = !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var smooth = motion ? 'smooth' : 'auto';
  var NAMES = { blue: 'Big Blue', bubblegum: 'Bubblegum', oat: 'Oat' };
  /* letters (with accents), spaces, hyphens, apostrophes, & and periods: what the band printer takes */
  var BAD = /[^A-Za-zÀ-ÖØ-öø-ɏ '’&.\-]/;

  function all(root, s) { return Array.prototype.slice.call(root.querySelectorAll(s)); }
  function once(el, key) { if (!el || el.getAttribute('data-kl-' + key)) return false; el.setAttribute('data-kl-' + key, '1'); return true; }
  function withWidth(src, w) { return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function emit(name, detail) { document.dispatchEvent(new CustomEvent(name, { detail: detail })); }
  /* product page: every pre-order button except the main one brings the visitor to color + name ([id=kl-pick]) */
  function goPick(tag) {
    var pick = document.getElementById('kl-pick'), form = document.getElementById('kl-buy-form');
    if (!pick) return false;
    if (form && tag) form.setAttribute('data-kl-via', tag);
    pick.scrollIntoView({ behavior: smooth, block: 'start' });
    clearTimeout(goPick.t);
    pick.classList.remove('is-flash'); void pick.offsetWidth; pick.classList.add('is-flash');
    goPick.t = setTimeout(function () { pick.classList.remove('is-flash'); }, 2200);
    var c = pick.querySelector('[data-kl-color]:checked') || pick.querySelector('[data-kl-color]');
    setTimeout(function () { try { (c || pick).focus({ preventScroll: true }); } catch (e) {} }, 500);
    return true;
  }
  /* honest countdown to the real end of the offer ([data-kl-ends] holds the date); hides once it has passed */
  function initEnds(el) {
    if (!once(el, 'endsrun')) return;
    var end = Date.parse(el.getAttribute('data-kl-ends')), out = el.querySelector('b'), word = el.getAttribute('data-kl-ends-label') || 'Ends in';
    if (isNaN(end) || !out) return;
    function two(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var left = end - Date.now();
      if (left <= 0) { el.hidden = true; return; }
      var s = Math.floor(left / 1000), d = Math.floor(s / 86400);
      if (d >= 2) out.textContent = word + ' ' + d + ' days';
      else out.textContent = word + ' ' + two(Math.floor(s / 3600)) + ':' + two(Math.floor(s / 60) % 60) + ':' + two(s % 60);
      el.hidden = false;
      setTimeout(tick, d >= 2 ? 60000 : 1000);
    }
    tick();
  }

  /* ---------- carousels: [data-kl-car] with [data-kl-track], [data-kl-prev], [data-kl-next] ---------- */
  function initCarousel(car) {
    if (!once(car, 'car')) return;
    var track = car.querySelector('[data-kl-track]');
    if (!track) return;
    var scope = car.closest('.kl') || car;
    var prevs = all(scope, '[data-kl-prev]').filter(function (b) { return !b.closest('[data-kl-gal]'); });
    var nexts = all(scope, '[data-kl-next]').filter(function (b) { return !b.closest('[data-kl-gal]'); });
    var center = car.hasAttribute('data-kl-center');
    function step() { var li = track.querySelector(':scope > li'); return li ? li.getBoundingClientRect().width + 20 : track.clientWidth * 0.8; }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prevs.forEach(function (b) { b.disabled = track.scrollLeft <= 2; });
      nexts.forEach(function (b) { b.disabled = track.scrollLeft >= max; });
      if (center) {
        var mid = track.getBoundingClientRect().left + track.clientWidth / 2, best = null, bestD = 1e9;
        all(track, ':scope > li').forEach(function (li) {
          var r = li.getBoundingClientRect(), d = Math.abs(r.left + r.width / 2 - mid);
          if (d < bestD) { bestD = d; best = li; }
        });
        all(track, ':scope > li').forEach(function (li) { li.classList.toggle('is-center', li === best); });
      }
    }
    prevs.forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: smooth }); }); });
    nexts.forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: smooth }); }); });
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    if (center && track.children.length > 2 && window.innerWidth >= 750) {
      var mid = track.children[Math.floor(track.children.length / 2)];
      track.scrollLeft = mid.offsetLeft - (track.clientWidth - mid.offsetWidth) / 2;
    }
    update();
  }

  /* ---------- videos: [data-kl-video] ---------- */
  function initVideo(card) {
    if (!once(card, 'vid')) return;
    var video = card.querySelector('video'), btn = card.querySelector('[data-kl-play]');
    if (!video || !btn) return;
    btn.addEventListener('click', function () {
      all(document, '[data-kl-video] video').forEach(function (v) { if (v !== video && !v.paused) { v.pause(); v.closest('[data-kl-video]').classList.remove('is-playing'); } });
      if (video.paused) { video.muted = false; video.play(); card.classList.add('is-playing'); }
      else { video.pause(); card.classList.remove('is-playing'); }
    });
    video.addEventListener('click', function () { video.pause(); card.classList.remove('is-playing'); });
    video.addEventListener('ended', function () { card.classList.remove('is-playing'); });
  }

  /* ---------- accordions: one open at a time inside [data-kl-single] ---------- */
  function initAccordion(group) {
    if (!once(group, 'acc')) return;
    all(group, 'details').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        all(group, 'details').forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }

  /* ---------- product page: gallery, color, name, form, sticky bar, dialogs ---------- */
  function initProduct(root) {
    if (!once(root, 'pdp')) return;
    function one(s) { return root.querySelector(s); }
    var gal = one('[data-kl-gal]'), track = one('[data-kl-gtrack]');
    var slides = all(root, '[data-kl-slide]'), thumbs = all(root, '[data-kl-thumb]');
    var count = one('[data-kl-count]'), prev = gal ? gal.querySelector('[data-kl-prev]') : null, next = gal ? gal.querySelector('[data-kl-next]') : null;
    var form = root.querySelector('#kl-buy-form') || one('[data-kl-form]'), input = one('[data-kl-input]'), chars = one('[data-kl-chars]');
    var hint = one('[data-kl-hint]'), hintText = hint ? hint.textContent : '';
    var variant = one('[data-kl-variant]'), colorName = one('[data-kl-colorname]'), go = one('[data-kl-go]');
    var ret = one('[data-kl-return]'), cartUrl = root.getAttribute('data-cart') || '/cart';
    var sticky = one('[data-kl-sticky]'), stickySel = one('[data-kl-sticky-color]'), stickyGo = one('[data-kl-sticky-go]');
    var bandSlide = slides.indexOf(one('[data-kl-bandslide]'));
    var current = 0, color = root.getAttribute('data-color') || 'blue', busy = false;

    function setSrc(img, c) {
      var base = img.getAttribute('data-src-' + c);
      if (!base) return;
      img.src = withWidth(base, img.getAttribute('data-w') || '1100');
      if (img.hasAttribute('srcset')) img.srcset = [600, 900, 1100, 1400].map(function (x) { return withWidth(base, x) + ' ' + x + 'w'; }).join(', ');
    }

    /* gallery */
    function goTo(i, how) {
      if (!track) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: how || smooth });
    }
    function setCurrent(i, force) {
      if (i === current && !force) return;
      current = i;
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      thumbs.forEach(function (t) {
        var on = +t.getAttribute('data-kl-thumb') === i, list = t.closest('ul');
        t.setAttribute('aria-current', on ? 'true' : 'false');
        if (on && list && list.scrollWidth > list.clientWidth) list.scrollTo({ left: t.parentNode.offsetLeft - list.clientWidth / 2 + t.offsetWidth / 2, behavior: smooth });
      });
    }
    if (track) {
      var raf;
      track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { setCurrent(Math.round(track.scrollLeft / track.clientWidth)); }); }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
      });
      window.addEventListener('resize', function () { goTo(current, 'auto'); });
    }
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(+t.getAttribute('data-kl-thumb')); }); });

    /* lightbox */
    var lb = one('[data-kl-lb]');
    if (lb && typeof lb.showModal === 'function' && slides.length) {
      var lbImg = lb.querySelector('[data-kl-lbimg]'), lbName = lb.querySelector('[data-kl-lbname]'), lbCap = lb.querySelector('[data-kl-lbcap]'), at = 0;
      var showLb = function (i) {
        at = (i + slides.length) % slides.length;
        var fig = slides[at], img = fig.querySelector('img'), tag = fig.querySelector('[data-kl-name]');
        lbImg.src = (img.currentSrc || img.src).replace(/width=\d+/, 'width=1400');
        lbImg.alt = img.alt;
        lbCap.textContent = (at + 1) + ' / ' + slides.length + '. ' + img.alt;
        lbName.hidden = !tag;
        if (tag) {
          lbName.className = tag.className;
          lbName.textContent = tag.textContent;
          lbName.style.fontSize = '';
          lbName.parentNode.setAttribute('data-color', color);
        }
      };
      var openLb = function (i) { showLb(i); lb.showModal(); requestAnimationFrame(function () { if (!lbName.hidden) fit(lbName); }); };
      slides.forEach(function (s, i) { s.addEventListener('click', function () { openLb(i); }); });
      var z = one('[data-kl-zoom]');
      if (z) z.addEventListener('click', function () { openLb(current); });
      lb.querySelector('[data-kl-lbprev]').addEventListener('click', function () { showLb(at - 1); if (!lbName.hidden) fit(lbName); });
      lb.querySelector('[data-kl-lbnext]').addEventListener('click', function () { showLb(at + 1); if (!lbName.hidden) fit(lbName); });
      lb.querySelector('[data-kl-lbclose]').addEventListener('click', function () { lb.close(); });
      lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
      lb.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') showLb(at + 1);
        if (e.key === 'ArrowLeft') showLb(at - 1);
      });
    }

    /* other dialogs (what's in the box) */
    all(root, '[data-kl-open]').forEach(function (b) {
      var d = root.querySelector('[data-kl-dialog="' + b.getAttribute('data-kl-open') + '"]');
      if (!d || typeof d.showModal !== 'function') return;
      b.addEventListener('click', function (e) { e.preventDefault(); d.showModal(); });
      all(d, '[data-kl-close]').forEach(function (c) { c.addEventListener('click', function () { d.close(); }); });
      d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
    });

    /* color */
    function setColor(radio, quiet) {
      color = radio.getAttribute('data-kl-color');
      root.setAttribute('data-color', color);
      if (colorName) colorName.textContent = NAMES[color] || radio.value;
      all(root, '[data-src-' + color + ']').forEach(function (img) { setSrc(img, color); });
      var id = radio.getAttribute('data-kl-variant-id');
      if (variant && id) {
        variant.value = id;
        variant.dispatchEvent(new Event('change', { bubbles: true }));
        if (!quiet && window.history && history.replaceState) {
          try { var url = new URL(window.location.href); url.searchParams.set('variant', id); history.replaceState(history.state, '', url.toString()); } catch (err) {}
        }
      }
      if (stickySel && stickySel.value !== color) stickySel.value = color;
      emit('klaar:color', { color: color, label: NAMES[color] || radio.value });
    }
    all(root, '[data-kl-color]').forEach(function (radio) { radio.addEventListener('change', function () { setColor(radio); }); });
    if (stickySel) stickySel.addEventListener('change', function () {
      var r = root.querySelector('[data-kl-color="' + stickySel.value + '"]');
      if (r && !r.disabled) { r.checked = true; setColor(r); }
    });

    /* name: optional, shown live on the photos and shrunk to fit the band */
    function clean() { return input ? input.value.replace(/\s+/g, ' ').trim() : ''; }
    function say(text, alert) { if (!hint) return; hint.textContent = text; hint.classList.toggle('is-alert', !!alert); }
    function fit(el) {
      el.style.fontSize = '';
      var r = document.createRange();
      r.selectNodeContents(el);
      var w = r.getBoundingClientRect().width, room = el.clientWidth * 0.9;
      if (w > room && room > 0) el.style.fontSize = (parseFloat(getComputedStyle(el).fontSize) * room / w) + 'px';
    }
    function fitAll() { all(root, '[data-kl-name]').forEach(fit); }
    function setName(e) {
      if (!input) return;
      if (!(e && e.isComposing) && BAD.test(input.value)) {
        var at = input.selectionStart, before = input.value.length;
        input.value = input.value.split('').filter(function (ch) { return !BAD.test(ch); }).join('');
        if (at != null && document.activeElement === input) { at -= before - input.value.length; input.setSelectionRange(at, at); }
        say('Letters, spaces, hyphens, apostrophes, & and periods only.', true);
      } else if (e && hint && hint.classList.contains('is-alert')) {
        say(hintText);
      }
      var v = clean();
      all(root, '[data-kl-name]').forEach(function (el) {
        el.textContent = v || input.placeholder;
        el.classList.toggle('is-example', !v);
        fit(el);
      });
      if (chars) chars.textContent = input.value.length + ' of ' + (input.maxLength > 0 ? input.maxLength : 12) + ' characters';
      emit('klaar:name', { name: v });
    }
    if (input) {
      input.addEventListener('input', setName);
      input.addEventListener('focus', function () {
        if (bandSlide > -1 && window.matchMedia('(min-width: 1000px)').matches && current !== 1 && current !== bandSlide) goTo(1);
      });
    }
    if ('ResizeObserver' in window && track) new ResizeObserver(fitAll).observe(track); else window.addEventListener('resize', fitAll);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);

    /* pre-order: one submit at a time; with other things in the cart, go to the cart first */
    function setBusy(on) { busy = on; if (go) { go.setAttribute('aria-disabled', on ? 'true' : 'false'); } }
    if (go && form) go.addEventListener('click', function () {
      var tag = form.querySelector('[data-kl-ctain]');
      if (tag && go.getAttribute('data-kl-cta')) tag.value = form.getAttribute('data-kl-via') || go.getAttribute('data-kl-cta');
    });
    if (form) {
      form.addEventListener('submit', function (e) {
        if (busy) { e.preventDefault(); return; }
        if (input) input.value = clean();
        setTimeout(function () { if (!e.defaultPrevented) { setBusy(true); setTimeout(function () { setBusy(false); }, 8000); } }, 0);
      });
    }
    function checkCart() {
      if (!ret || !window.fetch) return;
      fetch(cartUrl + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
        .then(function (c) { ret.value = c.item_count > 0 ? cartUrl : '/checkout'; }).catch(function () {});
    }
    window.addEventListener('pageshow', function () { setBusy(false); checkCart(); });

    /* sticky bar: shows once the main button has scrolled away; hides at [data-kl-end] */
    if (sticky && go) {
      var stickyOn = null, sraf = 0;
      var check = function () {
        sraf = 0;
        var g = go.getBoundingClientRect(), end = document.querySelector('[data-kl-end]'), vh = window.innerHeight;
        var past = g.bottom < 0;
        var atEnd = false;
        if (end) { var e = end.getBoundingClientRect(); atEnd = e.top < vh && e.bottom > 0; }
        var on = past && !atEnd;
        if (on === stickyOn) return;
        stickyOn = on;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        all(sticky, 'button,select').forEach(function (el) { el.tabIndex = on ? 0 : -1; });
      };
      var queue = function () { if (!sraf) sraf = requestAnimationFrame(check); };
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      check();
    }
    if (stickyGo && form) stickyGo.addEventListener('click', function () {
      if (goPick(stickyGo.getAttribute('data-kl-cta'))) return;
      var tag = form.querySelector('[data-kl-ctain]');
      if (tag && stickyGo.getAttribute('data-kl-cta')) tag.value = stickyGo.getAttribute('data-kl-cta');
      if (form.requestSubmit) form.requestSubmit(go); else go.click();
    });

    /* "watch a routine" links play the demo section if it is on the page */
    all(document, '[data-kl-playdemo]').forEach(function (el) {
      if (!once(el, 'demo')) return;
      el.addEventListener('click', function (e) {
        var demo = document.getElementById('kl-demo');
        if (!demo) return;
        e.preventDefault();
        demo.scrollIntoView({ behavior: smooth, block: 'start' });
        emit('klaar:demo-play');
      });
    });

    /* start */
    var start = root.querySelector('[data-kl-color]:checked');
    if (start) setColor(start, true);
    setName();
    setCurrent(0, true);
  }

  /* pre-order buttons elsewhere on the product page ([data-kl-submit], or links to #kl-buy) scroll to color + name */
  function initSubmitters(scope) {
    all(scope, '[data-kl-submit], a[href="#kl-buy"]').forEach(function (b) {
      if (!once(b, 'sub')) return;
      b.addEventListener('click', function (e) {
        var form = document.getElementById('kl-buy-form'), btn = form && form.querySelector('[data-kl-go]');
        if (!btn) return;
        e.preventDefault();
        if (goPick(b.getAttribute('data-kl-cta'))) return;
        var tag = form.querySelector('[data-kl-ctain]');
        if (tag && b.getAttribute('data-kl-cta')) tag.value = b.getAttribute('data-kl-cta');
        if (form.requestSubmit) form.requestSubmit(btn); else btn.click();
      });
    });
  }

  /* ---------- v3: ?v= test swaps, and the button tag that rides along to the order ---------- */
  function initTests() {
    var q = null;
    try { q = new URLSearchParams(location.search).get('v'); } catch (e) {}
    if (!q) return;
    var want = q.toLowerCase().split(',');
    all(document, 'script[data-kl-tests]').forEach(function (el) {
      if (!once(el, 'tests')) return;
      var rows; try { rows = JSON.parse(el.textContent); } catch (e) { return; }
      rows.forEach(function (r) {
        if (want.indexOf(r[0]) < 0) return;
        all(document, '[data-kl-key="' + r[1] + '"]').forEach(function (n) { n.innerHTML = r[2]; });
      });
    });
  }
  function initTags() {
    var from = '';
    try { var u = new URLSearchParams(location.search); from = u.get('cta') || u.get('from') || ''; } catch (e) {}
    from = from.replace(/[^A-Za-z0-9_-]/g, '').slice(0, 40);
    all(document, '[data-kl-from]').forEach(function (el) {
      if (from) { el.value = from; el.disabled = false; }
    });
  }
  /* home phone bar: shows once the hero button has scrolled away; hides at [data-kl-end] */
  function initBar(bar) {
    if (!once(bar, 'bar')) return;
    var anchor = document.querySelector('.kl-hero .kl-btn') || document.querySelector('.kl-hero');
    var on = null, raf = 0, links = all(bar, 'a');
    function check() {
      raf = 0;
      var past = anchor ? anchor.getBoundingClientRect().bottom < 0 : window.scrollY > 500;
      var end = document.querySelector('[data-kl-end]'), atEnd = false;
      if (end) { var r = end.getBoundingClientRect(); atEnd = r.top < window.innerHeight && r.bottom > 0; }
      var now = past && !atEnd;
      if (now === on) return;
      on = now;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      links.forEach(function (a) { a.tabIndex = on ? 0 : -1; });
    }
    function queue() { if (!raf) raf = requestAnimationFrame(check); }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    check();
  }

  /* comparison on phones: tabs pick which column sits next to Klaar */
  function initCompare(frame) {
    if (!once(frame, 'cmprun')) return;
    var box = frame.closest('.kl-cmp');
    if (!box) return;
    var tabs = all(box, '[data-kl-alt]');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        frame.setAttribute('data-alt', t.getAttribute('data-kl-alt'));
        tabs.forEach(function (o) { o.setAttribute('aria-selected', o === t ? 'true' : 'false'); });
      });
    });
  }

  function init(scope) {
    scope = scope || document;
    initTests();
    initTags();
    all(scope, '[data-kl-bar]').forEach(initBar);
    all(scope, '[data-kl-pdp]').forEach(initProduct);
    all(scope, '[data-kl-car]').forEach(initCarousel);
    all(scope, '[data-kl-video]').forEach(initVideo);
    all(scope, '[data-kl-single]').forEach(initAccordion);
    initSubmitters(scope);
    all(scope, '[data-kl-ends]').forEach(initEnds);
    all(scope, '[data-kl-cmp]').forEach(initCompare);
  }

  window.KlaarUI = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
